<app-dialog-heading [heading]="'SMSes'"></app-dialog-heading>


<ng-container *ngIf="isDataExist;
                  then showSms else emptySmsDataTable"></ng-container>

<ng-template #showSms>
  <div class="mat-elevation-z8 table-container">
    <table [dataSource]="smsDataSource" mat-table
           matSort multiTemplateDataRows
           (matSortChange)="sortData($event)">

      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>

          <mat-icon *ngIf="!row.sendSmsChecked && !row[tableColumns.IsSent]"
                    class="mat-primary-color hand-cursor font-medium" matTooltip="SEND sms to {{getToNumber(row)}}"
                    (click)="onClickToggleIcons($event, row)">send
          </mat-icon>

          <ng-container *ngIf="row[tableColumns.IsSent];">
            <!--Allow duplicate functionality for SMS -->
            <app-duplicate defaultIcon="redo"
                           tooltip="RESEND sms"
                           [customCssClasses]="['hand-cursor', 'font-medium']"
                           (duplicateItem)="OnClickDuplicate($event, row)"></app-duplicate>
          </ng-container>


          <mat-icon *ngIf="row.sendSmsChecked" class="mat-primary-color hand-cursor font-medium"
                    matTooltip="CONFIRM Send to {{getToNumber(row)}}"
                    (click)="onClickSendSmsConfirmed($event, row)">done
          </mat-icon>
          <mat-icon *ngIf="row.sendSmsChecked" class="hand-cursor font-medium"
                    matTooltip="CANCEL Send"
                    color="warn"
                    (click)="onClickToggleIcons($event, row)">
            close
          </mat-icon>

          <mat-icon *ngIf="row.smsSentBusyCounter > 0" class="m-l-10">
            <mat-spinner diameter="20"></mat-spinner>
          </mat-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.SmsId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>SMS ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.SmsId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ToNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Number</th>
        <td *matCellDef="let row" mat-cell>

          <ng-container>
            <ng-container *ngIf="!row[tableColumns.IsSent];">
              <mat-icon *ngIf="!row?.isEditNumber" class="mat-primary-color hand-cursor font-medium"
                        matTooltip="UPDATE number"
                        (click)="onClickEditNumber($event, row)">edit
              </mat-icon>
            </ng-container>
            <ng-container *ngIf="row?.isEditNumber; else displayNumber">
              <mat-form-field>
                <input [formControl]="smsOverrideFormControl" matInput/>
                <button (click)="onClickCancelEditNumber($event, row)" class="mr2"
                        mat-button mat-icon-button matSuffix>
                  <mat-icon matTooltip="Cancel edit" style="color: grey;">cancel</mat-icon>
                </button>
                <button (click)="onClickSaveNumber($event, row)"
                        mat-button mat-icon-button matSuffix>
                  <mat-icon class="table-icon" matTooltip="Save number">save</mat-icon>
                </button>
              </mat-form-field>
            </ng-container>

            <ng-template #displayNumber>
              <ng-container *ngIf="!row?.editedToNumber; else showEditedAddress">
                {{row[tableColumns.ToNumber] }}
              </ng-container>
              <ng-template #showEditedAddress>
                {{row?.editedToNumber}}
              </ng-template>
            </ng-template>
          </ng-container>

        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Message">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Message</th>
        <td *matCellDef="let row"
            [matTooltip]="row[tableColumns.Message]"
            mat-cell>{{row[tableColumns.Message] | truncateText: {sliceEnd: 30, append: '...'} }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsSent">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Sent</th>
        <td *matCellDef="let row" mat-cell> {{row[tableColumns.IsSent] ? 'Y' : 'N'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CommunicationTriggerType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Communication Type</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.CommunicationTriggerType]?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TriggerId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Trigger ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.TriggerId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.SmsTemplate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Class</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.SmsTemplate]?.processingClass?.name}}</td>
      </ng-container>

      <!--Expanded Section -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="smsDisplayedColumns.length" mat-cell>
          <div [@detailExpand]="row == smsExpandedRow ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="smsDisplayedColumns;" mat-header-row></tr>
      <tr class="row"
          mat-row
          *matRowDef="let row; columns: smsDisplayedColumns;"
          [class.expanded-row]="smsExpandedRow == row"
          (click)="onRowClick($event, row)">
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>

    <mat-paginator #smsPaginator
                   [length]="smsTableControl.length" [pageIndex]="0"
                   [pageSizeOptions]="smsTableControl.pageSizeOptions"
                   [pageSize]="smsTableControl.pageSize"
                   (page)="pageChanged($event)">
    </mat-paginator>
  </div>
</ng-template>


<ng-template #emptySmsDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No sms data</label>
  </div>
</ng-template>
